import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'

import ImportExportPage from '../components/ImportExportPage'
import ErrorPageComponent from '../../settings/component/ErrorPageComponent'


export default class ImportExportController {
    init(state, jQuery, mount_root_id) {
        if (!state) {
            this._renderError(mount_root_id)

            return
        }

        this._renderSettings(state, mount_root_id)
    }

    _renderSettings(context, mount_root_id) {
        const mount_root = document.getElementById(mount_root_id)
        if (!mount_root) {
            console.warn('нет элемента с id [' + mount_root_id + ']')

            return
        }

        ReactDOM.render(
            <ImportExportPage context={context}/>,
            mount_root
        )
    }

    _renderError(mount_root_id) {

        const mount_root = document.getElementById(mount_root_id)
        if (!mount_root) {
            console.warn('нет элемента с id [' + mount_root_id + ']')

            return
        }

        ReactDOM.render(
            <ErrorPageComponent/>,
            mount_root
        )
    }


}